module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "password-reset"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Lewis Rice",
      "src": require("../assets/images/lewis-rice-logo-white.svg")
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Estate Planning Document Portal")]), _vm._v(" "), (!_vm.resetComplete) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "readonly": "",
      "disabled": "",
      "placeholder": "email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "new password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    attrs: {
      "type": "password",
      "name": "confirmPassword",
      "placeholder": "confirm password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "disabled": !_vm.passwordsMatch,
      "type": "submit"
    },
    on: {
      "click": _vm.setPassword
    }
  }, [_vm._v("Set Password")])]), _vm._v(" "), _c('div', [_c('p', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Back to login")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.resetComplete) ? _c('div', [_c('h2', [_vm._v("Your password has been set.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('button', {
    staticClass: "btn btn-lg btn-primary"
  }, [_vm._v("Continue")])])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0848a6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordReset.vue
// module id = 286
// module chunks = 1